import { POManager } from '../components/POManager';
import { motion } from 'framer-motion';

export function Orders() {
    return (
        <div className="orders-page min-h-screen bg-background text-foreground transition-colors duration-300">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="h-full"
            >
                <POManager />
            </motion.div>
        </div>
    );
}
